import template from './contactsFilter.template.html';

export default {
  template,
  bindings: {
    filters: '<',
    contactLabels: '<',
    ticketLabels: '<',
    accounts: '<',
    showAccounts: '<',
    onApplied: '&',
    onClosed: '&'
  },
controller: class controller {
    constructor(
      $q,
      $scope,
      $rootScope,
      $filter,
      $timeout,
      actionService,
      Filter,
      FilterType,
      filterService,
      filtersService,
      uiService,
      dateTimeService,
      ContactGender,
      ContactEmploymentType,
      lendersService,
      helperService,
      CONTACT,
      ADDRESS
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.model = {};
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = $rootScope.CurrentOrganization.organization.location.cca2;
      ctrl.filtersList = null;
      ctrl.hasSelection = false;
      ctrl.isEditing = false;
      ctrl.isVisible = false;
      ctrl.isReady = true;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.filters = ctrl.filters || [];
        ctrl.contactLabels = ctrl.contactLabels || [];
        ctrl.ticketsLabels = ctrl.ticketLabels || [];
        ctrl.accounts = ctrl.accounts || [];
        ctrl.genders = ContactGender.available();
        ctrl.employments = ContactEmploymentType.available();
        ctrl.states = _.reject(ADDRESS.STATES, (_, index) => index === 0);
        ctrl.loanPurposes = [
          { id: 'in', title: 'Investment' },
          { id: 'oo', title: 'Owner occupied' }
        ];
        ctrl.repaymentTypes = [
          { id: 'io', title: 'Interest only' },
          { id: 'pi', title: 'Principal & Interest' }
        ];
        ctrl.rateTypes = [
          { id: 'fr', title: 'Fixed rate' },
          { id: 'vr', title: 'Variable rate' }
        ];

        lendersService
          .getAvailable({
            cca2: [helperService.getOrganizationCountry().cca2],
            type: 'RESIDENTIAL'
          })
          .then((lenders) => {
            ctrl.lenders = lenders;
          });

        ctrl.isVisible = true;
      };

      ctrl.listChange = (list, data, isSelected) => {
        ctrl.hasSelection = isSelected || list.isSelectedAny();
      };

      ctrl.listReady = (list) => {
        ctrl.filtersList = list;
      };

      ctrl.operatorToggle = (prop) => {
        ctrl.model[prop].operatorNot = !ctrl.model[prop].operatorNot;
      };

      ctrl.operatorClass = (prop) => ({
        'fab-red-hover': ctrl.model[prop].operatorNot === true,
        'fab-green-hover': ctrl.model[prop].operatorNot === false
      });

      ctrl.filterEdit = ($event, filter) => {
        $event.stopPropagation();
        ctrl.isEditing = true;
        ctrl.filter = filter || Filter.blank();

        // Init Filter model with Template
        ctrl.model = filterService.modelCompose(ctrl.filter, CONTACT.FILTERS);

        // Remap Name back to Model
        ctrl.model.name =
          _.get(ctrl.filter, 'name') || `Contact filter ${ctrl.filters.length + 1}`;

        dateTimeService.getSet(ctrl, ctrl.model.PERSON_DOB, 'values[0]', 'getSetDoBFrom');
        if (ctrl.model.PERSON_DOB.values[0]) {
          ctrl.getSetDoBFrom(
            moment.utc(ctrl.model.PERSON_DOB.values[0], 'X').format('YYYY-MM-DD')
          );
        }
        dateTimeService.getSet(ctrl, ctrl.model.PERSON_DOB, 'values[1]', 'getSetDoBTo');
        if (ctrl.model.PERSON_DOB.values[1]) {
          ctrl.getSetDoBTo(
            moment.utc(ctrl.model.PERSON_DOB.values[1], 'X').format('YYYY-MM-DD')
          );
        }
      };

      ctrl.filterApply = ($event, filterToApply, isList) => {
        $event.stopPropagation();

        if (isList) {
          ctrl.onApplied({
            idFilter: filterToApply.id,
            filterName: filterToApply.name
          });
          ctrl.isReady = false;
          return;
        }

        ctrl.filter.type = FilterType.contact;
        ctrl.filter.name = ctrl.model.name || `Contact filter ${ctrl.filters.length + 1}`;
        ctrl.filter.items = filterService.modelDecompose(ctrl.model);

        if (_.isEmpty(ctrl.filter.id)) {
          filterService.createFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: data.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        } else {
          filterService.updateFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: ctrl.filter.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        }
      };

      ctrl.filterDelete = () => {
        filtersService.clearCache();
        actionService
          .deleteDocuments(
            ctrl.filtersList.getSelected(),
            filterService.deleteFilter,
            ctrl.filtersList.removeData,
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterDuplicate = () => {
        filtersService.clearCache();
        actionService
          .duplicateDocuments(
            ctrl.filtersList.getSelected(),
            filterService.readFilter,
            filterService.createFilter,
            ctrl.filtersList.setDataAppend,
            'name',
            ' copy',
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterClose = () => {
        ctrl.isReady = false;
        ctrl.onClosed();
      };

      ctrl.filterCancel = ($event) => {
        $event.stopPropagation();
        ctrl.isEditing = false;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        $timeout(() => {
          ctrl.initialize();
        }, 250);
      };
    }
  }
};
